import { NgModule } from '@angular/core';

import { epicObs } from '../../../store';

import { WinningPercentageService } from './core';
import { mainEpics } from './main/main.epic';
import { CmpsCoachingWpMainModule } from './main/main.module';

@NgModule({
    exports: [CmpsCoachingWpMainModule],
    imports: [CmpsCoachingWpMainModule],
    providers: [WinningPercentageService],
})
export class CmpsCoachingWinningPercentageModule {
    constructor() {
        mainEpics.forEach((e) => epicObs.next(e));
    }
}
